import React, { useEffect, useState } from "react";
import {
  Button,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  useTheme,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import filesize from "filesize";
import FileIcon, { defaultStyles } from "react-file-icon";
import { LOCALE } from "../../properties/Locale";

export default function Upload(props) {
  const [files, setFiles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (props.files) {
      setFiles(props.files);
    }
  }, [props.files]);

  const handleDialogClose = () => {
    setOpenDialog(false);
    if (props.onClose) props.onClose();
    if (props.onUploadComponentClose) props.onUploadComponentClose(files);
  };

  const deleteFile = () => {
    setFiles([]);
  };

  const openFile = () => {
    const fileURL = URL.createObjectURL(files[0]);
    const pdfWindow = window.open();
    pdfWindow.location.href = fileURL;
  };

  return (
    <div>
      <label htmlFor="proofs-button-file">
        <Button
          variant="contained"
          component="span"
          style={{
            backgroundColor: props?.error
              ? theme.palette.error.light
              : theme.palette.primary.main,
          }}
          fullWidth
          size="small"
          onClick={() => setOpenDialog(!openDialog)}
        >
          <Icon>backup</Icon> &nbsp;{" "}
          {!props.disabled ? LOCALE.upload : LOCALE.download} (
          {files ? files.length : 0})
        </Button>
        {props?.error && (
          <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-marginDense">
            {" "}
            Задолжително прикачете скениран документ
          </p>
        )}
      </label>

      <Dialog
        open={openDialog}
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            overflowY: "unset",
          },
        }}
      >
        <DialogTitle>
          <IconButton
            style={{ float: "right" }}
            aria-label="close"
            onClick={() => handleDialogClose()}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {!props.disabled && (
            <DropzoneArea
              multiple={false}
              onChange={(files) => setFiles(files)}
              showFileNamesInPreview={false}
              showPreviews={false}
              showPreviewsInDropzone={false}
              filesLimit={1}
              dropzoneText={LOCALE.attach_file_here}
              acceptedFiles={[".png", ".pdf", ".jpg", ".jpeg"]}
            ></DropzoneArea>
          )}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{LOCALE.docType}</TableCell>
                <TableCell>{LOCALE.docName}</TableCell>
                <TableCell>{LOCALE.docSize}</TableCell>
                <TableCell style={{ width: "100px" }}>
                  {LOCALE.actions}
                </TableCell>
                <TableCell style={{ width: "100px" }}>
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {files &&
                files.map((attachment, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <FileIcon
                        size={50}
                        extension={
                          attachment.name?.split(".")[1]
                            ? attachment.name?.split(".")[1]
                            : ""
                        }
                        {...defaultStyles[
                          attachment.name?.split(".")[1]
                            ? attachment.name?.split(".")[1]
                            : ""
                        ]}
                      />
                    </TableCell>
                    <TableCell>
                      {attachment.name?.split(".")[0]
                        ? attachment.name?.split(".")[0]
                        : "/"}
                    </TableCell>
                    <TableCell>{filesize(attachment.size)}</TableCell>
                    <TableCell>
                      {!props.disabled && (
                        <IconButton
                          size="small"
                          color="secondary"
                          aria-label="open"
                          onClick={() => openFile()}
                        >
                          <Icon>visibility</Icon>
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell>
                      {!props.disabled && (
                        <IconButton
                          size="small"
                          color="secondary"
                          aria-label="delete"
                          onClick={() => deleteFile()}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            style={{ float: "right" }}
            color="secondary"
            onClick={() => handleDialogClose()}
          >
            {LOCALE.save}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
